module.exports = __webpack_public_path__ + "img/qrcode2.5b62d25f.png";